// ConfirmationDialog.js
import React from 'react';

const ConfirmLevel = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog-box">
      <span class="icon211362424200130"><i class="fa fa-times"></i></span>

        <div className='tjeuthetet24355'>

        احراز هویت سطح دوم لازم است!


              </div>

        <div className='kdjhsdfgfg837263624'>

          

        </div>

        <div className='jjshjvgfs0082736232'>

        برای انجام برداشت، لازم است ابتدا احراز هویت سطح دوم خود را تکمیل کنید. احراز هویت سطح دوم به امنیت بیشتر حساب شما کمک کرده و امکان دسترسی به امکانات بیشتری را فراهم می‌کند. 


        </div>
        <div className="dialog-actions">
          <button className="dialog-button panel-danger" onClick={onClose}>بازگشت</button>
          <button className="dialog-button" onClick={onConfirm}>تکمیل احراز هویت</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmLevel;
